import {
  authAPIRequest,
  baseAPIRequest,
  httpRequestMethods
} from '@/cllib/axios_init'
import * as url from './authorityUrl'

// user
export function userGetData (parm) {
  return authAPIRequest(url.user.basUrl, httpRequestMethods.GET, parm)
}

export function userResetPwd (id) {
  return authAPIRequest(url.user.resetPwd(id), httpRequestMethods.PUT)
}

export function userUpdatePwd (parm) {
  return authAPIRequest(url.user.updatePwd, httpRequestMethods.PUT, parm)
}

export function userGetPublicKey (parm) {
  return baseAPIRequest(url.user.getPublicKey, httpRequestMethods.GET, parm)
}

export function resetPwdNoToken (parm) {
  return baseAPIRequest(url.user.resetPwdNoToken, httpRequestMethods.POST, parm)
}

export function userGetOrgUser (parm) {
  return authAPIRequest(url.user.orgUser, httpRequestMethods.GET, parm)
}

export function userAddData (parm) {
  return authAPIRequest(url.user.basUrl, httpRequestMethods.POST, parm)
}

export function userAddUsers (parm) {
  return authAPIRequest(url.user.addUsers, httpRequestMethods.POST, parm)
}

export function userDelData (id) {
  return authAPIRequest(url.user.parmUrl(id), httpRequestMethods.DELETE)
}

export function userUpdateData (id, parm) {
  return authAPIRequest(url.user.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function userGetUserRole (id) {
  return authAPIRequest(url.user.getUserRole(id), httpRequestMethods.GET)
}

export function userUpdateUserRole (id, parm) {
  return authAPIRequest(url.user.updateUserRole(id), httpRequestMethods.POST, parm)
}

export function userGetUserPrivilege (id) {
  return authAPIRequest(url.user.getUserPrivilege(id), httpRequestMethods.GET)
}

export function userUpdateUserPrivilege (id, parm) {
  return authAPIRequest(url.user.updateUserPrivilege(id), httpRequestMethods.POST, parm)
}

// role
export function roleGetData (parm) {
  return authAPIRequest(url.role.basUrl, httpRequestMethods.GET, parm)
}

export function roleAddData (parm) {
  return authAPIRequest(url.role.basUrl, httpRequestMethods.POST, parm)
}

export function roleDelData (id) {
  return authAPIRequest(url.role.parmUrl(id), httpRequestMethods.DELETE)
}

export function roleUpdateData (id, parm) {
  return authAPIRequest(url.role.parmUrl(id), httpRequestMethods.PUT, parm)
}

export function roleGetRoleMenu (id) {
  return authAPIRequest(url.role.getRoleMenu(id), httpRequestMethods.GET)
}

export function roleUpdateRoleMenu (id, parm) {
  return authAPIRequest(url.role.updateRoleMenu(id), httpRequestMethods.POST, parm)
}

// menu
export function menuGetData (parm) {
  return authAPIRequest(url.menu.basUrl, httpRequestMethods.GET, parm)
}

export function menuAddData (parm) {
  return authAPIRequest(url.menu.basUrl, httpRequestMethods.POST, parm)
}

export function menuDelData (id) {
  return authAPIRequest(url.menu.parmUrl(id), httpRequestMethods.DELETE)
}

export function menuUpdateData (id, parm) {
  return authAPIRequest(url.menu.parmUrl(id), httpRequestMethods.PUT, parm)
}



// WEBPACK FOOTER //
// ./src/api/authorityApi.js